import api from './api';
import { User, CreateUserRequest, UpdateUserRequest, ChangePasswordRequest, UpdateUserDetailsRequest } from '@radevents/shared';

export const userService = {
  getAll: async (): Promise<User[]> => {
    const response = await api.get('/users');
    return response.data;
  },

  getById: async (id: number): Promise<User> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await api.post('/users', data);
    return response.data;
  },

  update: async (id: number, data: UpdateUserRequest): Promise<User> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  changePassword: async (id: number, data: ChangePasswordRequest): Promise<void> => {
    await api.post(`/users/${id}/change-password`, data);
  },

  updateLocation: async (location: string): Promise<User> => {
    const response = await api.patch('/auth/location', { location });
    return response.data;
  },

  /** Freiwillige Angaben: Geburtsjahr und Radarten (V187). */
  /** Heimatregion (V191): Profil und „Mitmachen“ der Winterchallenge. `null` löscht sie. */
  updateRegion: async (bundesland: string | null): Promise<User> => {
    const response = await api.patch('/auth/region', { bundesland });
    return response.data;
  },

  updateDetails: async (data: UpdateUserDetailsRequest): Promise<User> => {
    const response = await api.patch('/auth/details', data);
    return response.data;
  },
};

export default userService;
